import cardPainterManager from '../../../../../Widgets/DataPainterWidget/Core/CardPainterManager';
import { SOW_TARGET } from '../../../../../Widgets/DataPainterWidget/ScheduleOverviewWidget/scheduleOverviewConst';
import commandEngine from './CommandEngine';
import { CMD_SCHEDULE_OVERVIEW_REGISTRY_KEY, META_TYPE, META_VER } from './scheduleOverviewCommandRegisteryType';

/**
 * Registers the /schedules command with the CommandEngine.
 * /schedules — opens/refocuses the power schedule overview (single instance, target=all).
 */
export function registerScheduleOverviewCommand() {
    commandEngine.register('/schedules', {
        hint: 'open power schedule overview (all batteries)',
        params: [],
        handler: () => {
            cardPainterManager.openCard(CMD_SCHEDULE_OVERVIEW_REGISTRY_KEY, { type: META_TYPE, ver: META_VER, target: SOW_TARGET });
        },
    });
}
